module.exports = __webpack_public_path__ + "static/img/datachuli3.2b760965.png";